export enum EUserFormError {
  NO_RESULTS_FOUND = 'SFE0200',
  USER_DEACTIVATED = 'SFE0301',
  USER_ALREADY_ACTIVATED = 'SFE0304',
  INVALID_PRICE_LIST = 'SFE0306',
  NO_ADDRESSES = 'SFE0314',
  PHONE = 'SFE0313',
}

export enum EUserFormType {
  SINGLE_VIEW = 'SINGLE_VIEW',
  MULTI_VIEW = 'MULTI_VIEW',
  EDIT = 'EDIT',
  ACTIVATE = 'ACTIVATE',
}
